import styles from './styles.module.scss';

interface UserNameProps {
  name: string;
}

function UserName({ name }: UserNameProps) {
  return (
    <div className={styles.user}>
      <div />
      <h2>{name}</h2>
      <div />
    </div>
  );
}

export { UserName };
